export const environment = {
    production: false,
    plugins: [],
    apiUrl: 'https://staging.api.luxuraelite.ro',
    publishableKey: 'pk_live_51IW8FYJ1tmGNZzxOFJeLXTdKpZ9MzwrSbZRpLh3ZTeZwwIaOYUP8SQb4JlKEXOPn3hM27acsZ7QJyyU0A9bivhrs00DWFx09XU'
};
